// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const aqueductSpan = defineModel({
  id: "aqueduct-span",
  batchId: "future",
  name: "Aqueduct span",
  tags: ["building","aqueduct","span","low-poly","age-of-mcp","future","water"],
  summary: "Arches carrying a water channel — irrigation, mills and town supply.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.4, 0.5), color: "#9a958a", position: [-0.6, 0.34, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.4, 0.5), color: "#9a958a", position: [0, 0.34, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.4, 0.5), color: "#9a958a", position: [0.6, 0.34, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.8, 0.425, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.8, 0.425, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.8, 0.425, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.8, 0.425, 0.8] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.8, 0.5), color: "#9a958a", position: [-0.6, 0.54, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.8, 0.5), color: "#9a958a", position: [0, 0.54, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.8, 0.5), color: "#9a958a", position: [0.6, 0.54, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [-0.8, 0.65, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [0.8, 0.65, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [-0.8, 0.65, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [0.8, 0.65, 0.8] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.85, 0.5), color: "#9a958a", position: [-0.6, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.85, 0.5), color: "#9a958a", position: [0, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.85, 0.5), color: "#9a958a", position: [0.6, 0.565, 0] },
      { geometry: new THREE.TorusGeometry(0.26, 0.05, 6, 12, 3.141593), color: "#7c776c", position: [-0.3, 0.99, 0] },
      { geometry: new THREE.TorusGeometry(0.26, 0.05, 6, 12, 3.141593), color: "#7c776c", position: [0.3, 0.99, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.08, 0.42), color: "#857f74", position: [0, 1.03, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 0.05), color: "#9a958a", position: [0, 1.1, -0.18] },
      { geometry: new THREE.BoxGeometry(1.5, 0.14, 0.05), color: "#9a958a", position: [0, 1.1, 0.18] },
      { geometry: new THREE.BoxGeometry(1.46, 0.02, 0.28), color: "#3b6b86", position: [0, 1.1, 0] },
    ] },
  ],
  animations: [],
});
